import { library } from '@fortawesome/fontawesome-svg-core';
import { faUnlink } from '@fortawesome/free-solid-svg-icons';
import { useTranslator } from '@Localization';
import { Button } from '@mui/joy';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { ButtonWithLoader } from '../../../../design/buttons/ButtonWithLoader';
import { S_Modal } from '../../../../design/modals/modal/S_Modal';

library.add(faUnlink);

interface IUnlinkDatasetModalProps {
  show: boolean;
  hideModal: () => void;
  onConfirm: () => Promise<void>;
  onCancel: () => void;
}

export const UnlinkDatasetModal = observer((props: IUnlinkDatasetModalProps): ReactElement => {
  const { t } = useTranslator();

  return (
    <S_Modal
      isOpen={props.show}
      toggle={props.hideModal}
      headerText={t('unlink_dataset')}
      buttons={
        <>
          <Button
            color='neutral'
            variant='outlined'
            onClick={props.onCancel}
          >
            {t('cancel')}
          </Button>
          <ButtonWithLoader
            onClick={props.onConfirm}
            loaderKey='unlink-dataset-button'
          >
            {t('unlink')}
          </ButtonWithLoader>
        </>
      }
    >
      <p>{t('do_you_want_to_unlink_dataset')}</p>
      <p>
        <strong>{t('do_you_want_to_unlink_dataset_note')}</strong>
      </p>
    </S_Modal>
  );
});
